import { ElDialog, ElDrawer } from 'element-plus'

/**
 * 弹层仅允许点击右上角关闭，避免误触遮罩关闭（添加/编辑等表单场景）
 */
function disableOverlayClose(component) {
  if (component?.props?.closeOnClickModal) {
    component.props.closeOnClickModal.default = false
  }
  if (component?.props?.closeOnPressEscape) {
    component.props.closeOnPressEscape.default = false
  }
}

disableOverlayClose(ElDialog)
disableOverlayClose(ElDrawer)
